var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9038 0C6.31271 0 0.856934 5.36203 0.856934 11.9531C0.856934 18.5442 6.31271 24 12.9038 24C19.4949 24 24.8569 18.5442 24.8569 11.9531C24.8569 5.36203 19.4949 0 12.9038 0ZM19.2319 13.3594H14.3101V18.375C14.3101 19.1503 13.6787 19.7812 12.9038 19.7812C12.1285 19.7812 11.4976 19.1503 11.4976 18.375V13.3594H6.48193C5.70662 13.3594 5.07568 12.7284 5.07568 11.9531C5.07568 11.1778 5.70662 10.5469 6.48193 10.5469H11.4976V5.625C11.4976 4.84969 12.1285 4.21875 12.9038 4.21875C13.6787 4.21875 14.3101 4.84969 14.3101 5.625V10.5469H19.2319C20.0068 10.5469 20.6382 11.1778 20.6382 11.9531C20.6382 12.7284 20.0068 13.3594 19.2319 13.3594Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBlack);
export default __webpack_public_path__ + "static/media/plus_black.cc3afce8eb6491655c7e079d92d73a43.svg";
export { ForwardRef as ReactComponent };